import { SITE } from "@/config/site";
import { Reveal } from "@/components/Reveal";
import { BookButton } from "@/components/GoldButton";
import { StarPattern } from "@/components/Ornament";
import { openChittiChat } from "@/lib/analytics";

export function FinalCta() {
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      className="relative overflow-hidden px-5 py-28 text-center sm:py-36 lg:py-44"
    >
      <StarPattern id="final-pattern" opacity={0.14} />
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_50%_60%,rgba(212,175,55,0.14),transparent_60%)]"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-4xl">
        <Reveal>
          <p dir="rtl" lang="ur" className="font-urdu text-3xl leading-relaxed text-[#D4AF37] sm:text-4xl">
            {SITE.urdu}
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display gold-text mt-6 text-5xl leading-[1.05] tracking-tight sm:text-6xl lg:text-7xl">
            CHITTI
            <br />
            AYEE HAI
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="font-accent mx-auto mt-6 max-w-xl text-lg italic leading-relaxed text-[#C8C2B7] sm:text-xl">
            The letter has arrived. Do not miss the mehfil — {SITE.date}.
          </p>
        </Reveal>
        <Reveal delay={0.26}>
          <div className="mt-12">
            <BookButton location="final" label="Tickets Are Live" testId="final-book-tickets-btn" />
            <p className="mt-5 text-sm text-[#918A7E]">
              From ₹{SITE.priceFrom} on BookMyShow · {SITE.listingStatus}
            </p>
            <button
              type="button"
              data-testid="final-ask-chitti-link"
              onClick={() => openChittiChat("final_cta")}
              className="mt-6 inline-flex items-center gap-1.5 text-xs font-semibold uppercase tracking-[0.14em] text-[#8FD9BE] underline decoration-[#1C6B52]/40 underline-offset-4 transition-colors hover:text-[#B7EAD3]"
            >
              Still deciding? Ask Chitti AI on WhatsApp
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
